import React from 'react';
import Image from 'next/image';

const ValuePropositionAiStrategy = () => {
    return (
        <div className="section-py relative bg-black">
            <div className="bg-agriculture-numbers">
            <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                <source src="media/aiml-section.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="container xl:container mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-8 grid">
                        <h2 className="text-white mb-2.5">
                            Value Proposition
                        </h2>
                        <p className='dark:text-[#D7DEE5] mb-2.5'>
                            AI roadmaps, feasibility analysis & implementation strategy - data-driven plans.
                        </p>
                        <p className='dark:text-[#D7DEE5] mb-0'>
                            Our Strategic AI planning focuses on creating data-driven AI roadmaps built on thorough AI feasibility analysis. With AI business case development and ROI modeling, we prioritize AI opportunities that deliver tangible results fast. Our AI implementation strategy aligns technology stack evaluation and pilot design with your broader enterprise goals, ensuring accelerated AI transformation and sustainable success.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Problem we solve</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            We clarify AI adoption paths to prevent resource drain, align pilots with business goals, avoid costly delays, unify scattered AI efforts, and prioritize high-ROI AI opportunities to reduce executive uncertainty.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                           width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Core capabilities</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            We assess AI maturity, build ROI-backed business cases, develop tailored AI roadmaps, evaluate tech stacks, plan change management, and execute proof-of-concept pilots.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                        <Image
                            src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            width={36}
                                height={36}
                        />
                        </div>
                        <p className="text-white mb-2 font-bold">Outcomes</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Accelerate time-to-value by 3-6 months, boost project success by 40%, save over $2 million, and deliver 5-10 prioritized AI projects with clear ROI and impact.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ValuePropositionAiStrategy;
